import React          from 'react';
import { Redirect }   from 'react-router-dom';
import Instructor     from './Instructor';
import InstructorList from './InstructorList';

export const InstructorConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path      : '/instructor/:view_type/:instructor_id',
            component : Instructor,
            permission: { component_name: 'instructor', permission_type: 'view_type' },
        },
        {
            path      : '/instructor/list',
            component : InstructorList,
            permission: { component_name: 'instructor', permission_type: 'list' },
        },
        {
            path      : '/instructor/:view_type/',
            component : Instructor,
            permission: { component_name: 'instructor', permission_type: 'view_type' },
        },
        {
            path      : '/instructor',
            component : () => <Redirect to="/instructor/list" />,
            permission: { component_name: 'instructor', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/instructor/InstructorConfig.js